import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tag, Tooltip, ConfigProvider } from '@app/ui';

interface DisplayHashtagsProps {
    hashtags?: string[];
}

const DisplayHashtags: React.FC<DisplayHashtagsProps> = ({ hashtags = [] }) => {
    const { t } = useTranslation('measurement');
    const [expanded, setExpanded] = useState(false);

    const toggleExpanded = () => setExpanded(prev => !prev);

    const [first, rest] = [hashtags.slice(0, 2), hashtags.slice(2)];

    const renderTags = (arr: string[]) =>
        arr.map((hashtag, i) => (
            <ConfigProvider
                key={i}
                theme={{
                    token: {
                        colorBorder: '#009FDF',
                    },
                    components: {
                        Tag: {
                            defaultBg: '#E6F4FF',
                            defaultColor: '#009FDF',
                        },
                    },
                }}
            >
                <Tooltip title={`${hashtag}`} key={i}>
                    <Tag
                        style={{
                            maxWidth: 90,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                    >
                        {hashtag}
                    </Tag>
                </Tooltip>
            </ConfigProvider>
        ));

    return (
        <>
            {renderTags(first)}
            {!expanded && rest.length > 0 && (
                <div
                    onClick={toggleExpanded}
                    className="gds-text--link"
                    style={{ cursor: 'pointer' }}
                >
                    {t('socialMediaExposure.table.moreItems', {
                        count: rest.length,
                    })}
                </div>
            )}
            {expanded && renderTags(rest)}
        </>
    );
};

export default DisplayHashtags;
